module.exports = "<ul class=ipt_elmList> <% _.each(duration, function(obj, idx){ %> <li class=ipt_elmList_item> <span class=\"inr ipt_data ipt_chkBoxWrap\"><input id=\"dmy_cb_00-<%= idx %>\" class=forcia-state value=\"<%= obj.code %>\" type=checkbox name=duration <%= obj.chkStatus %> ><label for=\"dmy_cb_00-<%= idx %>\"><%= obj.name  %> [<%= obj.count %>件]</label></span> </li> <% }); %> </ul> <div class=ipt_layer_btm> <p><a href=# class=\"forcia-state-count ipt_btnBK icon_arwWT_rgt\" data-state='{\"subLayer\": \"\"}'>設定する</a></p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./web/WEB-INF/js/client/search/templates/duration.template.html
// module id = 65
// module chunks = 2